import React from 'react';
function FormJsx(prop) {
    const { renderJsx, value, ...rest } = prop || {};
    return React.createElement("div", null, renderJsx?.(value, rest));
}
FormJsx.displayName = 'FormJsx';
export { FormJsx };
